import { Section } from '@shared/components/Section';
import { Ficha } from '@shared/components/moldes';
import { BotaoDeContato } from '@inscricao/components/Contato';
import { curso, descontos, regraDosDescontos } from '@curso/content/curso';

/**
 * O preço e quem paga menos.
 *
 * Fica logo abaixo do resumo de propósito. Quem decide inscrever a equipe
 * chega ao valor sem caçar, e boa parte do público tem direito a desconto sem
 * saber: colaborador do complexo, residente, pós-graduando.
 *
 * O bloco institucional não publica e-mail, por decisão de 19/10: a pessoa
 * deixa o contato e a coordenação procura. Enquanto não existir onde guardar,
 * o formulário não guarda nada e diz isso.
 */
export function Investimento() {
  return (
    <>
      <Section
        id="investimento"
        rotulo="Investimento"
        titulo={`${curso.preco} por participante`}
      >
        <p className="prosa">
          {curso.cargaHoraria} de formação, {curso.horasPresenciais}&nbsp;horas presenciais,{' '}
          {curso.cenarios}&nbsp;cenários e turma de {curso.turma}. Uma experiência híbrida desenhada
          para transformar princípios de fatores humanos em ferramentas e comportamentos
          aplicáveis ao trabalho em equipe na saúde.
        </p>

        <p className="rotulo mt-9">Descontos institucionais</p>
        <div className="mt-3">
          <Ficha
            linhas={descontos.map((desconto) => ({
              rotulo: desconto.quanto,
              valor: desconto.quem,
            }))}
          />
        </div>

        <p className="mt-4 text-apoio text-tinta-suave">{regraDosDescontos}</p>
      </Section>

      <Section
        id="turma-pequena"
        rotulo="O tamanho da turma"
        titulo={`Por que apenas ${curso.turma}?`}
      >
        <p className="prosa">
          A turma reduzida permite participação ativa nos cenários, trabalho em pequenos grupos,
          observação estruturada e discussão durante os debriefings.
        </p>
      </Section>

      <Section
        id="in-company"
        rotulo="Para instituições"
        titulo="Leve a experiência HCRM para a sua equipe"
      >
        <p className="prosa max-w-xl">
          Sua instituição tem interesse em inscrever mais de um profissional? Deixe seu contato
          para conversarmos sobre as possibilidades e condições especiais para inscrições
          institucionais.
        </p>
        <div className="mt-8 max-w-xl">
          <BotaoDeContato finalidade="institucional" origem="in-company" />
        </div>
      </Section>
    </>
  );
}
